import { render, staticRenderFns } from "./Dashboard-tap.vue?vue&type=template&id=6fa2dabc&"
import script from "./Dashboard-tap.vue?vue&type=script&lang=js&"
export * from "./Dashboard-tap.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard-tap.vue?vue&type=style&index=0&id=6fa2dabc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports